export default {
    name: "Vikaru CMS",

    s3Region: "eu-west-1",

    defaultLanguage: "nl",

    use2FA: true,

    usePremiumValue: false,

    useExternalIDs: false,

    slideEnabled: true,

    enableAds: false,

    hasPayingCustomers: false,

    allowInsertFromExcel: false,

    allowPartnerContractUpload: false,

    defaultCoverSize: "lg",

    logo: "platform/logo.png",

    
    thumbor_server: "fc-vikaru-img.usendes.com",

    enablePpv: true,

    enableRssFeeds: true,

    enableFlexSubscriptions: true
}
